import { render, staticRenderFns } from "./MenuChip.vue?vue&type=template&id=05ebefd3&"
import script from "./MenuChip.vue?vue&type=script&setup=true&lang=ts&"
export * from "./MenuChip.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05ebefd3')) {
      api.createRecord('05ebefd3', component.options)
    } else {
      api.reload('05ebefd3', component.options)
    }
    module.hot.accept("./MenuChip.vue?vue&type=template&id=05ebefd3&", function () {
      api.rerender('05ebefd3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/doctors/components/ChipsFilters/MenuChip.vue"
export default component.exports